import { Fragment } from "react"
import { convertNumber } from "utils"
import { TableTotalCOA } from "./table-total-coa"
import { BalanceSheetReportType } from "../types"
import { ImArrowUp, ImArrowDown } from "react-icons/im";

type TableBodyProps = {
  list: Array<BalanceSheetReportType>
  item: BalanceSheetReportType
  displayAccountNumber: boolean
  displaySubHeader: boolean
  displayDetail: boolean
}

export function TableBody({ list, item, displayAccountNumber, displaySubHeader, displayDetail }: TableBodyProps) {
  const isNormalFontWeight = [3].includes(item.header_level)
  const isNetAssets = item.coa_name === "NET ASSETS"
  const isNetProfit = item.coa_name === "NET PROFIT"
  const isDisplaySubHeader = item.header_level === 2 && displaySubHeader
  const isDisplayDetail = item.header_level === 3 && displayDetail


  const tdClass = `text-right w-[200px] ${isNormalFontWeight ? "font-normal" : "font-bold"}`


  return (
    <Fragment>
      <tr
        key={item.coa_id}
        style={{ display: isDisplayDetail || isDisplaySubHeader || item.header_level === 1 ? "table-row" : "none" }}
      >
        <td>
          <span
            className={isNormalFontWeight ? "font-normal" : "font-bold"}
            style={{ marginLeft: (item.coa_level - 1) * 24 }}>

            {item.coacode && (
              <span className="me-2 text-nowrap">
                {displayAccountNumber ? item.coacode : ""}
              </span>
            )}

            <span className={displayAccountNumber && item.coacode ? "border-s-[1px] pe-3" : "border-none"} />
            <span className="text-nowrap">{`${item.coa_name}`}</span>
          </span>
        </td>

        {isNetAssets || isNetProfit || item.header_level === 3 ? item.actual?.map((actual, index) => (
          <td key={actual + index} className={tdClass}>
            {convertNumber(actual).intoCurrency}
          </td>
        )) : item?.actual?.map((_) => (<td />))}

        {isNetAssets || isNetProfit || item.header_level === 3 ? item.budget?.map((budget, index) => (
          <td key={budget + index} className={tdClass}>
            {convertNumber(budget).intoCurrency}
          </td>
        )) : item?.budget?.map((_) => (<td />))}

        {isNetAssets || isNetProfit || item.header_level === 3 ? item.variance?.map((variance, index) => (
          <td key={variance + index} className={tdClass}>
            <div className="flex items-center justify-end gap-2">
              {convertNumber(Math.abs(variance)).intoCurrency}
              {variance > 0 ? (
                <ImArrowDown className="text-green-500" />
              ) : variance < 0 ? (
                <ImArrowUp className="text-red-500" />
              ) : null}
            </div>
          </td>
        )) : item?.variance?.map((_) => (<td />))}

        {isNetAssets || isNetProfit || item.header_level === 3 ? item.percent_variance?.map((percentVariance, index) => (
          <td key={percentVariance + index} className={tdClass}>
            {`${convertNumber(percentVariance).intoNormalAmount} %`}
          </td>
        )) : item?.percent_variance?.map((_) => (<td />))}


      </tr>

      {list.map((sub, key) => {
        if (sub.parent_id === item.coa_id) {
          return (
            <TableBody
              key={sub.coa_id + key}
              list={list}
              item={sub}
              displayAccountNumber={displayAccountNumber}
              displaySubHeader={displaySubHeader}
              displayDetail={displayDetail}
            />
          )
        }
        return <Fragment />
      })}

      {(isDisplaySubHeader || isDisplayDetail) && item.header_level !== 3 ? <TableTotalCOA item={item} /> : null}
    </Fragment>
  )
}
